<template>
  <a-form ref="advertisementForm" :model="form" layout="vertical" class="mt-10">
    <a-divider orientation="center">
      New Tiktok
    </a-divider>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="User Name">
          <a-input v-model:value="form.username" placeholder="User name" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Post Id">
          <a-input v-model:value="form.post_id" placeholder="Post Id" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Description">
          <a-textarea
            v-model:value="form.description"
            placeholder="Description"
            :rows="6"
          />
        </a-form-item>
      </a-col>
      <a-col :span="4">
        <a-form-item label="Likes">
          <a-input v-model:value="form.likes" placeholder="Likes" />
        </a-form-item>
      </a-col>
      <a-col :span="4">
        <a-form-item label="Views">
          <a-input v-model:value="form.views" placeholder="Views" />
        </a-form-item>
      </a-col>
      <a-col :span="4">
        <a-form-item label="Shares">
          <a-input v-model:value="form.shares" placeholder="Shares" />
        </a-form-item>
      </a-col>
      <a-col :span="4">
        <a-form-item label="Comments">
          <a-input v-model:value="form.comments" placeholder="Comments" />
        </a-form-item>
      </a-col>
      <a-col :span="4">
        <a-form-item label="Duration">
          <a-input v-model:value="form.duration" placeholder="Duration" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Music Title">
          <a-input v-model:value="form.music_title" placeholder="Music Title" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="Created Time">
          <a-input
            v-model:value="form.created_time"
            placeholder="Created Time"
          />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="Created For">
        <a-month-picker
            placeholder="Created For"
            v-model:value="form.created_for"
            picker="month"
            format="YYYY-MM"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
      <a-form-item label="Tiktok Link">
          <a-input v-model:value="form.tiktok_link" placeholder="Tiktok Link" />
        </a-form-item>

        
      </a-col>
      <div class="grid grid-cols-6 gap-5">
        <div>
          <a-form-item label="Is Ad">
            <Switch v-model="form.is_ad" />
          </a-form-item>
        </div>
        <div>
          <a-form-item label="New">
            <Switch v-model="form.new" />
          </a-form-item>
        </div>
        <div>
          <a-form-item label="Is Free">
            <Switch v-model="form.is_free" />
          </a-form-item>
        </div>
      </div>
    </a-row>

    <a-row :gutter="20">
      <a-col :span="8">
        <a-form-item label="Industry">
          <div class="custom_select--group">
            <CustomSelect
              v-model="form.industry"
              :options="industries"
              @onchange="handleIndustry"
            />
          </div>
        </a-form-item>
      </a-col>

      <a-col :span="8">
        <a-form-item label="Media Type">
          <a-radio-group
            v-model="media_type"
            @change="handleMediaType"
            button-style="solid"
          >
            <a-radio-button value="drive">
              Drive
            </a-radio-button>
            <a-radio-button value="file">
              File
            </a-radio-button>
            <a-radio-button value="link">
              Link
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Media">
          <input
            type="file"
            @change="onFileChanged"
            v-if="media_type == 'file'"
          />
          <a-input
            v-model:value="form.download_link"
            placeholder="Name"
            v-if="media_type !== 'file'"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20"> </a-row>
  </a-form>
</template>

<script>
import CustomSelect from "@/components/CustomSelect";
import Switch from "@/components/UI/Switch.vue";

export default {
  components: { CustomSelect, Switch },
  props: {
    modelValue: Object,
    mediaType: String,
  },

  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
  },
  computed: {
    media_type: {
      get() {
        return this.mediaType;
      },
      set(newValue) {
        this.$emit("update:mediaType", newValue);
      },
    },
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },

    industries() {
      return this.$store.state.industries;
    },
  },
  methods: {
    handleMediaType(value) {
      this.media_type = value.target.value;
    },
    onFileChanged(event) {
      this.form.download_link = event.target.files[0];
    },
  },
};
</script>

<style></style>
